import ProductContainer from './component.jsx'
export default ProductContainer
